import React from 'react';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import { Permissions, userHasPermission } from 'services/Authorization';
import strings from 'strings';
import FPIconButton from 'UI/components/atoms/FPIconButton';

import { ARCHIVED_ACTIONS } from '../ArchiveActions.constants';

const BUTTON_CONFIG = {
  [ARCHIVED_ACTIONS.Archive]: {
    icon: ArchiveIcon,
    title: strings.dailyPlan.tableAction.archive
  },
  [ARCHIVED_ACTIONS.Restore]: {
    icon: UnarchiveIcon,
    title: strings.dailyPlan.tableAction.restore
  }
};

export const ArchiveActionsButton = ({ onClick = () => {}, mode = null }) => {
  if (!userHasPermission(Permissions.DailyPlan.CanUseModule) || !mode) return null;

  if (!BUTTON_CONFIG) return null;

  return (
    <FPIconButton
      data-testid={`${mode}-actions-btn`}
      icon={BUTTON_CONFIG[mode].icon}
      iconProps={{
        onSetColor: ({ primary }) => primary.main
      }}
      onClick={onClick}
      showTooltipWhenDisabled
      tooltipProps={{
        arrow: false,
        placement: 'bottom',
        title: BUTTON_CONFIG[mode].title
      }}
    />
  );
};
